import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';

( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.marquee-slider' ).each( ( key, marquee ) => {
        const splide = new Splide( marquee, {
          type: 'loop',
          autoWidth: true,
          arrows: false,
          gap: '44px',
          pagination: false,
          autoScroll: {
            pauseOnHover: false,
            speed: .5,
          },
        } );


        splide.mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'marquee', COMPONENT );
} )( app );
